export default "__VITE_ASSET__BdF6IhBI__"